import Layout2 from '@/layout/Layout2'
let ja = require('../../common/lang/ja')
let zh = require('../../common/lang/zh-CN')

export default [{
  path: '/order',
  component: Layout2,
  children: [{
    path: '',
    name: 'order',
    component: () => import('@/merchanAdmin/order/OrderList'),
    meta: {
      zhtitle: zh.m.router.common.ORDER,
      jatitle: ja.m.router.common.ORDER,
      pername: "order_list"
    },
  }, {
    path: '/orderDetail',
    name: 'orderDetail',
    component: () => import('@/merchanAdmin/order/OrderDetail'),
    meta: {
      zhtitle: zh.m.router.common.EDIT,
      jatitle: ja.m.router.common.EDIT,
      pername: "order_list"
    },
  }
  ]
}]
